module.exports = __webpack_public_path__ + "assets/images/ert_sports2.8056d3041fd22efd7243c4f0ac93da26.png";